import React from 'react';
import { graphql, useFragment } from 'react-relay';
import { Text } from '@atlaskit/primitives/compiled';
import type { issueTypeGroupHeader_issueTableGrouping$key } from '@atlassian/jira-relay/src/__generated__/issueTypeGroupHeader_issueTableGrouping.graphql';

export type Props = {
	issueTypeGroupHeader: issueTypeGroupHeader_issueTableGrouping$key | null;
};

export const IssueTypeGroupHeader = ({ issueTypeGroupHeader }: Props) => {
	const data = useFragment<issueTypeGroupHeader_issueTableGrouping$key>(
		graphql`
			fragment issueTypeGroupHeader_issueTableGrouping on JiraJqlIssueTypeFieldValue {
				issueTypes {
					name
				}
			}
		`,
		issueTypeGroupHeader,
	);

	// TODO: [JSC-2193] stubbed for now, will follow up with a PR to implement the component as per designs
	return <Text>{data?.issueTypes?.[0]?.name}</Text>;
};
